import { render, staticRenderFns } from "./ReleaseCard.vue?vue&type=template&id=609c0d7f&"
import script from "./ReleaseCard.vue?vue&type=script&lang=js&"
export * from "./ReleaseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports